import type { ChecklistTemplateItem } from '../templates/types';
import type { ChecklistItemResult } from './types';

export function hasPrimitiveChecklistValue(result: Pick<ChecklistItemResult, 'value_bool' | 'value_option' | 'value_number' | 'value_text'> | null | undefined) {
  return Boolean(result && (result.value_bool !== null || result.value_option !== null || result.value_number !== null || Boolean(result.value_text?.trim())));
}

export function hasChecklistAnswer(result: ChecklistItemResult | null | undefined) {
  if (!result) return false;
  if (result.status === 'not_applicable_with_reason') {
    return Boolean(result.note?.trim());
  }
  if (hasPrimitiveChecklistValue(result)) {
    return true;
  }
  return result.status === 'problem' && Boolean(result.note?.trim());
}

export function isChecklistItemSatisfied(item: ChecklistTemplateItem, result: ChecklistItemResult | null | undefined) {
  if (!item.is_required) {
    return hasChecklistAnswer(result);
  }
  return hasChecklistAnswer(result);
}

export function countSatisfiedChecklistItems(items: ChecklistTemplateItem[], results: Record<string, ChecklistItemResult>) {
  return items.filter((item) => isChecklistItemSatisfied(item, results[item.id])).length;
}

/**
 * 1.23.0 — версия счётчика для multi-section заявок. Принимает массив
 * пар [templateItem, resultKey] вместо плоского списка items: ключи
 * берутся явно из FlatChecklistItem.resultKey, а не выводятся как
 * `item.id` (что некорректно для multi-section, где один template-id
 * фигурирует в двух секциях с разными composite-ключами).
 */
export function countSatisfiedChecklistItemsByKeys(
  pairs: Array<{ templateItem: ChecklistTemplateItem; resultKey: string }>,
  results: Record<string, ChecklistItemResult>,
): number {
  return pairs.filter(({ templateItem, resultKey }) =>
    isChecklistItemSatisfied(templateItem, results[resultKey]),
  ).length;
}

export function countChecklistStatuses(results: Record<string, ChecklistItemResult>) {
  return Object.values(results).reduce(
    (acc, result) => {
      if (result.status === 'problem') acc.problem += 1;
      if (result.status === 'not_applicable_with_reason') acc.notApplicable += 1;
      return acc;
    },
    { problem: 0, notApplicable: 0 },
  );
}
